<template>
  <div class="wrap wrap-content">
    <span class="title">{{title}}</span>
    <div class="button-group">
      <slot name="operate"></slot>
    </div>
    <slot></slot>
  </div>
</template>
<script>
  export default {
    name: 'wrap',
    props: {
      title: {
        type: String,
        default: '数据列表'
      }
    },
    data () {
      return {}
    },
    mounted () {

    },
    methods: {

    }
  }
</script>
<style scoped lang="scss">
  @import "../../styles/variables";
  .wrap-content {
    .title {
      display: inline-block;
      padding: 0 10px;
      margin-bottom: 10px;
      border-left: 5px solid $themeColor;
      font-size: 15px;
      font-weight: bold;
    }
    .button-group {
      margin-bottom: 10px;
      float: right;
    }
  }
</style>
